import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { api } from '../../lib/api'
import {
  getAffiliateBrowserId,
  getStoredAffiliateReferral,
  storeAffiliateReferralCode,
} from '../../lib/affiliateAttribution'
import { useAuth } from '../../hooks/useAuth'

export function AffiliateAttributionManager() {
  const location = useLocation()
  const { user } = useAuth()
  const lastCapturedRef = useRef<string | null>(null)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const referralCode = searchParams.get('ref')
    if (!referralCode) return

    const normalizedCode = referralCode.trim().toLowerCase()
    if (!normalizedCode || lastCapturedRef.current === normalizedCode) return
    lastCapturedRef.current = normalizedCode

    storeAffiliateReferralCode(normalizedCode)

    const browserId = getAffiliateBrowserId()
    const payload = {
      referral_code: normalizedCode,
      browser_id: browserId,
      landing_path: `${location.pathname}${location.search}`,
      referral_source: 'query' as const,
      utm_source: searchParams.get('utm_source'),
      utm_medium: searchParams.get('utm_medium'),
      utm_campaign: searchParams.get('utm_campaign'),
      utm_content: searchParams.get('utm_content'),
      utm_term: searchParams.get('utm_term'),
    }

    api.affiliate.captureReferral(payload).catch((err) => {
      console.warn('[Affiliate] Capture failed:', err)
    })
  }, [location.pathname, location.search])

  useEffect(() => {
    if (!user?.id) return
    const storedReferral = getStoredAffiliateReferral()
    if (!storedReferral?.referral_code) return

    const claimKey = `affiliate_claimed_${user.id}_${storedReferral.referral_code}`
    if (sessionStorage.getItem(claimKey) === 'true') return

    const browserId = getAffiliateBrowserId()
    api.affiliate
      .claimReferral(browserId)
      .then(() => {
        sessionStorage.setItem(claimKey, 'true')
      })
      .catch((err) => {
        console.warn('[Affiliate] Claim failed:', err)
      })
  }, [user?.id])

  return null
}
